/**
 * Frontend performance logger - helps identify bottlenecks (slow API, navigation).
 * Enable with REACT_APP_PERF_LOG=1. Slow API threshold: REACT_APP_PERF_SLOW_MS (default 1000).
 */
const ENABLED = process.env.REACT_APP_PERF_LOG === '1';
const SLOW_MS = parseInt(process.env.REACT_APP_PERF_SLOW_MS, 10) || 1000;

let navigationCount = 0;
const sessionStart = typeof performance !== 'undefined' ? performance.now() : Date.now();

export function logApiCall(method, endpoint, durationMs, ok) {
  if (!ENABLED) return;
  const slow = durationMs >= SLOW_MS;
  const line = `[PERF] API ${method} ${endpoint} ${durationMs}ms ${ok ? 'OK' : 'ERR'}${slow ? ' SLOW' : ''}`;
  if (slow) {
    console.warn(line);
  } else {
    console.log(line);
  }
}

export function logNavigation(pathname) {
  if (!ENABLED) return;
  navigationCount += 1;
  const elapsed = typeof performance !== 'undefined' ? Math.round(performance.now() - sessionStart) : 0;
  console.log(`[PERF] Navigation #${navigationCount} → ${pathname} (session elapsed: ${elapsed}ms)`);
}

export function getNavigationCount() {
  return navigationCount;
}

export default { logApiCall, logNavigation, getNavigationCount, ENABLED, SLOW_MS };
